import React, { ChangeEvent, useEffect } from "react";
import {
  icon_normal,
  kirkos_logo_white_yellow,
  car_sign_in,
} from "../../assets/images";
// import iconcus from "../../assets/images/kirkos_logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  CustomInput,
  CustomerOnboardLeftSide,
  RegistrationSuccessModal,
  // Progressbar,
} from "../../components";
import { Form, useForm } from "react-hook-form";
import rules from "../../rules";
import { useState, useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { trackEvent } from "../../services/events";
import { API_URL } from "../../services/apiConfig";
import axiosInstance from "../../services/axios.instance";
import { ForgotPasswordData, RegistrationData } from "../../types";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ERROR_MESSAGES } from "../../utils/messages";
// import { forEachLeadingCommentRange } from "typescript";
//import { navigate, useNavigate } from "react-router-dom";
import { SuccessModal } from "../../components";
import { ErrorModal } from "../../components";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import "./Customer_Newpassword.css";
import "../Customer/signin/styles.css";
import "../Customer/signin/SignInScreen.css";
import SEO from "../../components/SEO";

const Customernewpassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null); // New state variable for error
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const createPasswordRef = useRef<HTMLInputElement>(null);
  const confirmPasswordRef = useRef<HTMLInputElement>(null);

  const { state } = useLocation();
  const phoneNo = state && state.phoneNo;
  const verifiedOtp = state && state.otp;
  const transactionId = sessionStorage.getItem("transactionId");

  useEffect(() => {
    if (confirmPassword && password !== confirmPassword) {
      setError("Passwords do not match");
    } else {
      setError(null);
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    const trackPageLoad = async () => {
      await trackEvent({
        event_name: { web: "Kirkos_UpdatePasswordScreen", app: "Kirkos_UpdatePasswordScreen_App" },
        event_category: "SignIn",
        module: "Login",
        payload: {},
      });
    };
    trackPageLoad();
  }, []);

  const handleInputChange = (name: string, value: string) => {
    if (name === "password") {
      setPassword(value);
    }
  };

  const {
    control,
    formState: { isValid },
    setValue,
    trigger,
    getValues,
  } = useForm({ mode: "onChange" });

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setError(null);

    await trackEvent({
      event_name: { web: "Kirkos_UpdatePasswordButton", app: "Kirkos_UpdatePasswordButton_App" },
      event_category: "SignIn",
      module: "Login",
      payload: {},
    });
    const formData = getValues();
    try {
      const userData: ForgotPasswordData = {
        phoneNo: phoneNo ?? "",
        new_password: formData.createpassword,
        user_type: "CONSUMER",
        transaction_id: transactionId,
        // otp: verifiedOtp || "1111",
        otp: "1111",
        event: "forgot_password",
      };

      const registrationResponse = await handleRegistration.mutateAsync(
        userData
      );

      if (registrationResponse.status && registrationResponse?.data?.message) {
      }
    } catch (error: any) {
      if (error?.data?.message) {
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      } else {
        setErrorMessage(ERROR_MESSAGES.DEFAULT_ERROR);
        setShowErrorModal(true);
      }
    }

    setIsFormSubmitted(true);
  };

  const handleRegistration = useMutation({
    mutationFn: (userData: ForgotPasswordData) =>
      axiosInstance.post(API_URL.FORGOT_PASSWORD, userData),
    onSuccess: async (successResponse) => {
      await trackEvent({
        event_name: { web: "Kirkos_UpdatePasswordSuccess", app: "Kirkos_UpdatePasswordSuccess_App" },
        event_category: "SignIn",
        module: "Login",
        payload: {
          status: "success",
          message: successResponse?.data?.message ?? "",
        },
      });

      if (successResponse.status && successResponse?.data?.message) {
        // alert(successResponse?.data?.message);
        setShowSuccessModal(true);
        // navigate("./welcome");
      }
    },
    onError: async (error: any) => {
      await trackEvent({
        event_name: { web: "Kirkos_UpdatePasswordFailed", app: "Kirkos_UpdatePasswordFailed_App" },
        event_category: "SignIn",
        module: "Login",
        payload: {
          status: "failed",
          message: error?.data?.message ?? error?.message ?? "Unknown error",
        },
      });

      if (error?.data?.message) {
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      } else {
        setErrorMessage(ERROR_MESSAGES.DEFAULT_ERROR);
        setShowErrorModal(true);
      }
    },
  });

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };

  return (
    <div className="customer-signin-page">
      <SEO
        title="Reset Password | Kirkos Security"
        description="Create a new password for your Kirkos account to ensure your security and continue enjoying our car rental services."
        keywords="reset password, kirkos security, new password, car hire account"
      />
      <div className="customer-signin-shell">
        {/* Left Side: Brand Panel */}
        <div className="customer-signin-brand-panel">
          <div className="customer-signin-brand-topbar">
            <Link to="/" className="customer-signin-logo-link" aria-label="Kirkos home">
              <img
                src={kirkos_logo_white_yellow}
                alt="Kirkos"
                className="customer-signin-logo"
              />
            </Link>
            <div className="customer-signin-brand-links">
              <Link to="/" className="customer-signin-brand-link">
                Home
              </Link>
              <Link to="/signin" className="customer-signin-brand-link">
                Login
              </Link>
            </div>
          </div>

          <div className="customer-signin-brand-content">
            <span className="customer-signin-eyebrow">Security</span>
            <h1 className="customer-signin-brand-title">
              Enjoy your Trips with our wheels
            </h1>
            <p className="customer-signin-brand-copy">
              Get ready to hit the road with confidence. Your next generation
              adventure begins here.
            </p>

            <div className="customer-signin-brand-highlights">
              <div className="customer-signin-highlight-card">
                <span className="customer-signin-highlight-value">Secure</span>
                <span className="customer-signin-highlight-label">
                  Encrypted password protection
                </span>
              </div>
              <div className="customer-signin-highlight-card">
                <span className="customer-signin-highlight-value">UAE</span>
                <span className="customer-signin-highlight-label">
                  Trusted mobility partner
                </span>
              </div>
              <div className="customer-signin-highlight-card">
                <span className="customer-signin-highlight-value">24/7</span>
                <span className="customer-signin-highlight-label">
                  Always here to help
                </span>
              </div>
            </div>

            <div className="customer-signin-car-stage">
              <div className="customer-signin-car-glow" />
              <img
                src={car_sign_in}
                className="customer-signin-car-image"
                alt="Kirkos premium rental car"
              />
            </div>
          </div>
        </div>

        {/* Right Side: New Password Card */}
        <div className="customer-signin-card">
          <Form onSubmit={handleSubmit} control={control}>
            <div className="customer-signin-card-header">
              <div className="customer-signin-card-icon-wrap">
                <img
                  src={icon_normal}
                  className="customer-signin-card-icon"
                  alt="Security"
                />
              </div>
              <span className="customer-signin-card-kicker">Security</span>
              <h2 className="customer-signin-heading">New Password</h2>
              <p className="customer-signin-subcopy">
                Create a strong password to protect your Kirkos account.
              </p>
              <div className="customer-signin-links-row">
                <span className="customer-signin-links-label">
                  Remembered your password?
                </span>
                <Link to="/signin" className="customer-signin-inline-link">
                  Login
                </Link>
              </div>
            </div>

            <div className="customer-signin-form-area">
              <div className="customer-signin-field-block">
                <label className="customer-signin-label">Create a New Password</label>
                <div
                  className="customer-signin-input-shell"
                  onClick={() => createPasswordRef.current?.focus()}
                >
                  <CustomInput
                    inputName="createpassword"
                    inputType={showPassword1 ? "text" : "password"}
                    className="customer-signin-input"
                    placeholder="Enter new password"
                    editable={true}
                    onInputChange={(value: string) => setPassword(value)}
                    control={control}
                    rules={rules.AuthRules.password}
                    inputRef={createPasswordRef}
                  />
                  <button
                    type="button"
                    className="customer-signin-password-toggle"
                    onClick={(e) => {
                      e.stopPropagation();
                      togglePasswordVisibility1();
                    }}
                  >
                    {showPassword1 ? <EyeSlash /> : <Eye />}
                  </button>
                </div>
              </div>

              <div className="customer-signin-field-block mt-3">
                <label className="customer-signin-label">Confirm New Password</label>
                <div
                  className="customer-signin-input-shell"
                  onClick={() => confirmPasswordRef.current?.focus()}
                >
                  <CustomInput
                    inputName="confirmpassword"
                    inputType={showPassword2 ? "text" : "password"}
                    className="customer-signin-input"
                    placeholder="Re-enter password"
                    editable={true}
                    onInputChange={(value: string) => setConfirmPassword(value)}
                    control={control}
                    inputRef={confirmPasswordRef}
                  />
                  <button
                    type="button"
                    className="customer-signin-password-toggle"
                    onClick={(e) => {
                      e.stopPropagation();
                      togglePasswordVisibility2();
                    }}
                  >
                    {showPassword2 ? <EyeSlash /> : <Eye />}
                  </button>
                </div>
                {error && <p className="customer-signin-error">{error}</p>}
              </div>

              <button
                className="customer-signin-submit mt-4"
                type="submit"
                disabled={!isValid || !!error || !password || !confirmPassword}
              >
                UPDATE PASSWORD
              </button>

              <div className="customer-signin-support-strip">
                <span className="customer-signin-support-title">
                  Secure password tips
                </span>
                <span className="customer-signin-support-copy">
                  Use at least 8 characters with a mix of letters, numbers, and symbols to ensure your account remains safe.
                </span>
              </div>
            </div>
          </Form>

          <RegistrationSuccessModal
            isOpen={showSuccessModal}
            onClose={() => setShowSuccessModal(false)}
            onNavigateToDashboard={() => {
              navigate("/signin");
            }}
            title="Password Updated!"
            description="Your password has been successfully reset. You can now use your new credentials to sign in."
            buttonText="Sign in Now"
          />
          <ErrorModal
            isOpen={showErrorModal}
            onClose={() => setShowErrorModal(false)}
            message={errorMessage || ERROR_MESSAGES.DEFAULT_ERROR}
          />
        </div>
      </div>
    </div>
  );
};

export default Customernewpassword;
